// extracted by mini-css-extract-plugin
export var faq = "ComponentSharedCollapsibleList-module--faq--ed09d";
export var section = "ComponentSharedCollapsibleList-module--section--128d4";
export var title = "ComponentSharedCollapsibleList-module--title--dcca6";